// @flow
import React from 'react';
import classNames from 'classnames';
import { VerticalLoadingBar } from 'components/atoms/verticalLoadingBar';
import squirrelIcon from 'assets/images/squirrel.svg';
import hamburgerIcon from 'assets/images/Hamburger-Menu-v3_Black-3.png';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  isMobile?: boolean,
};

export const PageLoader = (props: Props) => {
  const { isMobile } = props;
  const loaderClassNames = classNames('page-loader', {
    mobile: isMobile,
  });

  return (
    <>
      <div className={loaderClassNames}>
        <div className={'menu-icon-container'}>
          <div className={'menu-icon'}>
            <img
              className={'menu-icon-img'}
              src={hamburgerIcon}
              alt={'ham-menu'}
            />
          </div>
        </div>
        <div className={'content-container'}>
          <div className={'loading-bar-container'}>
            <VerticalLoadingBar />
          </div>
        </div>
        <div className={'squirrel-icon-container'}>
          <img
            className={'squirrel-icon-img'}
            src={squirrelIcon}
            alt={'Total Environment Logo'}
          />
        </div>
      </div>
      <p className={'website-placeholder'}>
        <img src={squirrelIcon} alt={'Total Environment'} />
      </p>
    </>
  );
};
